/* Selected Wallpapers — levertijd-product (extern gemaakt 14-09-2026, was inline; laadt 1x per pagina, cache) */
(function(){
  if (window.__swLtProductAsset) return; window.__swLtProductAsset = 1;
function swCfgAll(name){ return Array.prototype.slice.call(document.querySelectorAll('script[data-sw-cfg="' + name + '"]')); }
function swCfgParse(el){ try { return JSON.parse(el.textContent || '{}'); } catch(e){ return {}; } }
function swVariants(sectionId, fallback){ var el = sectionId ? document.getElementById('VariantData-' + sectionId) : null; if (el) { try { var v = JSON.parse(el.textContent || '[]'); if (Array.isArray(v)) return v; } catch(e){} } return Array.isArray(fallback) ? fallback : []; }
function swReady(fn){ if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  function init(cfg){

                    var root = document.getElementById(cfg.rootId);
                    if(!root || root.__swLtDone) return; root.__swLtDone = 1;

                    function isSampleTitle(t){
                      if(!t) return false;
                      t = String(t).toLowerCase();
                      return t.indexOf('sample') !== -1 || t.indexOf('muster') !== -1;
                    }

                    function findProductForm(){
          var formId = root.getAttribute('data-product-form-id');
          if(formId){
            var f = document.getElementById(formId);
            if(f) return f;
          }
          var forms = document.querySelectorAll('form[action*="/cart/add"]');
          return (forms && forms.length) ? forms[forms.length-1] : null;
        }

                    function getSelectedVariantId(form){
                      var idInput = form ? form.querySelector('input[name="id"]') : null;
                      return (idInput && idInput.value) ? idInput.value : null;
                    }

                    var variants = swVariants(cfg.sectionId);
                    var variantLevertijden = {};
                    try {
                      var variantJsonEl = root.querySelector('[data-levertijd-variants]');
                      if (variantJsonEl) variantLevertijden = JSON.parse(variantJsonEl.textContent || '{}') || {};
                    } catch(e) {
                      variantLevertijden = {};
                    }

                    function getVariantById(id){
                      if(!id) return null;
                      for(var i=0;i<variants.length;i++){
                        if(String(variants[i].id) === String(id)) return variants[i];
                      }
                      return null;
                    }

                    function findPropertyInput(form, key){
                      var inputs = form.querySelectorAll('input[type="hidden"][name^="properties["]');
                      for(var i=0;i<inputs.length;i++){
                        if(inputs[i].name === ('properties[' + key + ']')) return inputs[i];
                      }
                      return null;
                    }

                    function ensurePropertyInput(form, key){
                      var input = findPropertyInput(form, key);
                      if(!input){
                        input = document.createElement('input');
                        input.type = 'hidden';
                        input.name = 'properties[' + key + ']';
                        form.appendChild(input);
                      }
                      return input;
                    }

                    function removePropertyInput(form, key){
                      var input = findPropertyInput(form, key);
                      if(input) input.remove();
                    }

                    function swAantal(form){
                      // het aantalveld staat soms buiten het formulier (form-attribuut): via form.elements vinden we beide
                      var q = form ? ((form.elements && form.elements.namedItem('quantity')) || form.querySelector('input[name="quantity"]')
                                      || (form.id ? document.querySelector('input[name="quantity"][form="' + form.id + '"]') : null)) : null;
                      if (q && q.length && !q.value) q = q[0];
                      var n = q ? parseInt(q.value || '1', 10) : 1;
                      return (isFinite(n) && n > 0) ? n : 1;
                    }

                    function swBbvKeuze(b, q){
                      if (!b || typeof b.voorraad !== 'number' || !(q > b.voorraad)) return null;
                      var st = b.stappen || [];
                      for (var i = 0; i < st.length; i++){ if (q <= st[i].tot) return st[i]; }
                      return b.standaard || (st.length ? st[st.length - 1] : null);
                    }

                    function update(){
                      var form = findProductForm();
                      if(!form) return;

                      var key = root.getAttribute('data-cart-key') || 'Levertijd';
          key = String(key).replace(/\s+/g,' ').trim();
                      var normalHtml = root.getAttribute('data-normal-html') || '';
                      var sampleHtml = root.getAttribute('data-sample-html') || '';
                      var cartValueNormal = root.getAttribute('data-cart-value-normal') || '';
                      var cartValueSample = root.getAttribute('data-cart-value-sample') || '';
                      var hideIfNoStock = (root.getAttribute('data-hide-if-no-stock') === 'true');

                      var vid = getSelectedVariantId(form);
                      var v = getVariantById(vid);
                      var variantPayload = (vid && variantLevertijden[String(vid)]) ? variantLevertijden[String(vid)] : null;

                      var title = v && v.title ? v.title : '';
                      var sample = variantPayload ? !!variantPayload.sample : isSampleTitle(title);

                      if (variantPayload){
                        normalHtml = variantPayload.normal_html || normalHtml;
                        sampleHtml = variantPayload.sample_html || sampleHtml;
                        cartValueNormal = variantPayload.cart_value_normal || cartValueNormal;
                        cartValueSample = variantPayload.cart_value_sample || cartValueSample;
                      }

                      // Bestellen boven voorraad (Kevin 08-10-2026): meer dan de voorraad = de hele order op de latere levering
                      var bbvKeuze = (variantPayload && !sample) ? swBbvKeuze(variantPayload.bbv, swAantal(form)) : null;
                      if (bbvKeuze){
                        normalHtml = bbvKeuze.html;
                        cartValueNormal = ' ' + bbvKeuze.datum;
                      }

                      var shouldHide = false;
                      if (variantPayload){
                        shouldHide = !!variantPayload.hide;
                      } else {
                        if(hideIfNoStock && v && v.inventory_management === 'shopify' && typeof v.inventory_quantity === 'number' && v.inventory_quantity < 1){
                          shouldHide = true;
                        }
                        // Also hide when variant is sold out (v.available === false) for non-sample products
                        if(v && v.available === false && !(v.price === 0)){
                          shouldHide = true;
                        }
                      }

                      var textEl = root.querySelector('[data-levertijd-text]');
                      if(!textEl) return;

                      if(shouldHide){
                        root.style.display = 'none';
                        removePropertyInput(form, key);
                        return;
                      } else {
                        root.style.display = '';
                      }

                      if(sample){
                        textEl.innerHTML = sampleHtml;
                        ensurePropertyInput(form, key).value = cartValueSample;
                      } else {
                        textEl.innerHTML = normalHtml;
                        ensurePropertyInput(form, key).value = cartValueNormal;
                      }

                      refreshFromServer();
                    }

                    // SWP FIX (12-06-2026): CDN-cache kan verouderde datums in de
                    // data-attributen bevriezen. Haal per variant 1x verse waarden
                    // op via de lightweight view (templates/product.levertijd.json)
                    // en laat update() daarna de property-input bijwerken.
                    var __ltFresh = {};
                    function refreshFromServer(){
                      try{
                        var f = findProductForm(); if(!f) return;
                        var vid = getSelectedVariantId(f); if(!vid) return;
                        if(__ltFresh[vid]) return;
                        __ltFresh[vid] = true;
                        var u = location.pathname.split('?')[0] + '?view=levertijd&variant=' + encodeURIComponent(vid) + '&_=' + Date.now();
                        fetch(u, {credentials:'same-origin', headers:{'Accept':'text/html'}}).then(function(r){
                          return (r && r.ok) ? r.text() : null;
                        }).then(function(html){
                          if(!html) return;
                          var doc = new DOMParser().parseFromString(html, 'text/html');
                          var fresh = doc.querySelector('[data-levertijd]');
                          if(!fresh) return;
                          var fKey = fresh.getAttribute('data-cart-key');
                          var fCartN = fresh.getAttribute('data-cart-value-normal');
                          var fCartS = fresh.getAttribute('data-cart-value-sample');
                          /* Alleen de (onzichtbare) cart-property verversen.
                             De zichtbare weergave blijft de originele block-opmaak. */
                          if(fKey) root.setAttribute('data-cart-key', fKey);
                          if(fCartN) root.setAttribute('data-cart-value-normal', fCartN);
                          if(fCartS) root.setAttribute('data-cart-value-sample', fCartS);
                          var vp = variantLevertijden[String(vid)];
                          if(vp){
                            if(fCartN) vp.cart_value_normal = fCartN;
                            if(fCartS) vp.cart_value_sample = fCartS;
                          }
                          update();
                        }).catch(function(){});
                      }catch(e){}
                    }

                    update();

                    // Try a few common variant-change patterns
                    document.addEventListener('variant:change', update);
                    document.addEventListener('variant:changed', update);

                    var form = findProductForm();
                    if(form){
                      var idInput = form.querySelector('input[name="id"]');
                      if(idInput){
                        idInput.addEventListener('change', update);
                        idInput.addEventListener('input', update);

                        var obs = new MutationObserver(function(){ update(); });
                        obs.observe(idInput, { attributes: true, attributeFilter: ['value'] });
                      }
                    }
                  
                    // Extra robustness: themes may update the hidden variant input via JS without firing events
                    // or mutating the 'value' attribute. Add a lightweight poll + URL watcher.
                    if (!window.__SW_ltWatchers) window.__SW_ltWatchers = {};
                    var ltKey = (root && root.id) ? root.id : ('lt-' + Math.random().toString(16).slice(2));
                    if (!window.__SW_ltWatchers[ltKey]) {
                      window.__SW_ltWatchers[ltKey] = true;

                      function getVidFromUrl(){
                        try { return new URL(location.href).searchParams.get('variant'); } catch(e){ return null; }
                      }

                      var lastVid = null;
                      var lastUrlVid = null;
                      var lastQty = null;

                      function poll(){
                        var f = findProductForm();
                        var idInput = f ? f.querySelector('input[name="id"]') : null;
                        var nowVid = (idInput && idInput.value) ? String(idInput.value) : null;
                        var nowUrl = getVidFromUrl();
                        var nowQty = f ? swAantal(f) : null;
                        if (nowQty !== lastQty){ lastQty = nowQty; update(); }

                        if (nowVid && nowVid !== lastVid){
                          lastVid = nowVid;
                          update();
                        }

                        if (nowUrl && nowUrl !== lastUrlVid){
                          lastUrlVid = nowUrl;
                          // Give the theme a moment to update its state/UI
                          setTimeout(update, 0);
                          setTimeout(update, 80);
                        }
                      }

                      // Catch option pickers (swatches/selects)
                      document.addEventListener('change', function(){ setTimeout(update, 0); }, true);

                      lastUrlVid = getVidFromUrl();
                      setInterval(poll, 250);
                    }

  }
  function boot(){ swCfgAll('levertijd-product').forEach(function(el){ if (el.__swDone) return; el.__swDone = 1; try { init(swCfgParse(el)); } catch(e){ if (window.console) console.error('levertijd-product', e); } }); }
  swReady(boot);
  document.addEventListener('shopify:section:load', boot);
})();
